import React, { useContext, useRef } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { AppContext } from "contexts/AppContext";

// Product Pages - START
// // admin
import Layout from "./Layout.js";
import AdminLayout from "./AdminLayout.js";
//import Dashboard from "pages/admin/Dashboard.js";
import Home from "pages/admin/Home.js";
import User from "pages/admin/User.js";
import { Users as UsersAdmin } from "pages/admin/Users.js";
import Client from "pages/admin/Client.js";
import Clients from "pages/admin/Clients.js";
import ContentEditor from "pages/admin/ContentEditor.js";
import { Agents as AgentsOld } from "pages/admin/Agents";
import Agent from "pages/admin/Agent";
import MediaItem from "pages/admin/MediaItem";
import Tables from "pages/admin/Tables.js";
import WebRTC from "pages/admin/WebRTC.js";
import Workflows from "pages/admin/Workflows";
import Workflow from "pages/admin/Workflow";
import WorkflowGraph from "pages/admin/WorkflowGraph";
import WorkflowGraph2 from "pages/admin/WorkflowGraph2";
import Nodes from "pages/admin/Nodes";
import Node from "pages/admin/Node";
import Functions from "pages/admin/Functions";
import Function from "pages/admin/Function";
import SupportingContent from "pages/admin/SupportingContent";
import EmailCampaign from "pages/admin/EmailCampaign";
import EmailCampaigns from "pages/admin/EmailCampaigns";
//import SupportingContentList from "pages/admin/SupportingContentList";
import Lesson from "pages/admin/Lesson";
import Lessons from "pages/admin/Lessons";

// // auth
import Login from "pages/auth/Login.js";
import Register from "pages/auth/Register.js";
import Reset from "pages/auth/Reset.js";

import Test from "pages/Test.js";

// // e-commerce
import Checkout from "pages/e-commerce/Checkout.js";
import ECommerce from "pages/e-commerce/ECommerce.js";
import Invoice from "pages/e-commerce/Invoice.js";
import Pricing from "pages/e-commerce/Pricing.js";
import Product from "pages/e-commerce/Product.js";
import Profile1 from "pages/e-commerce/Profile1.js";
import Settings1 from "pages/e-commerce/Settings1.js";
// // error
import Error404 from "pages/error/Error404.js";
import Error500 from "pages/error/Error500.js";
// // presentation
import Landing1 from "pages/presentation/Landing1.js";
import Landing2 from "pages/presentation/Landing2.js";
import AboutUs from "pages/presentation/AboutUs.js";
import ContactUs from "pages/presentation/ContactUs.js";
import PrivateRoute from "components/PrivateRoute";

// App Pages
import ParentingTrick from "pages/apps/ParentingTrick.js";

// New Pages
import Dashboard from "pages/new/Dashboard";
import Agents from "pages/new/Agents";
import ChatSessions from "pages/new/ChatSessions";
import Responses from "pages/new/Responses";
import Media from "pages/new/Media";
import { SupportingContent as NewSupportingContent } from "pages/new/SupportingContent";
import SupportingContentItems from "pages/new/SupportingContentItems";
import Events from "pages/new/Events";
import Courses from "pages/new/Courses.js";
import Emails from "pages/new/Emails";
import Messages from "pages/new/Messages";
import Settings from "pages/new/Settings";
import Train from "pages/new/Train";
import Users from "pages/new/Users";
import Usage from "pages/new/Usage";
import Models from "pages/new/Models";
import ApiKeys from "pages/new/ApiKeys";
import AppData from "pages/new/AppData";
import AdminModels from "pages/admin/Models";
import AdminApiKeys from "pages/admin/ApiKeys";
import AdminDatasetTypes from "pages/admin/DatasetTypes";
import WorkflowNodes from "pages/admin/WorkflowNodes";
import LiveEvents from "pages/new/LiveEvents";
import EditLiveEvent from "pages/new/liveevent/EditLiveEvent";
import RecordLiveEvent from "pages/new/liveevent/RecordLiveEvent";
import LiveEventDetails from "pages/new/LiveEventDetails";
import Data from "pages/new/Data";
import DataSets from "pages/new/DataSets";
import EditDataSet from "pages/new/dataset/EditDataSet";

import EditWorkflow from "pages/new/workflow/EditWorkflow";
import EditAgent from "pages/new/agent/EditAgent";
import EditCourse from "pages/new/course/EditCourse";
import GenerateCourse from "pages/new/course/GenerateCourse";
import EditCourseLevel from "pages/new/course/levels/EditCourseLevel";
import EditLevelSection from "pages/new/course/levels/sections/EditLevelSection";
import { useAuthContext } from "contexts/AuthContext";

const Router = () => {
  const { activeUser } = useAuthContext();
  const isAdmin = activeUser?.user_type.includes("admin");
  //const isAdmin = true;
  const { hasPlatformFeature } = useContext(AppContext);
  const foundDefaultRoute = useRef(false)

  return (
    <BrowserRouter>
      <Routes>
        {/* Product Pages - START */}
        {/* admin */}
        <Route
          path="/test"
          exact
          element={
            <PrivateRoute>
              <Test />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          exact
          element={
            <AdminLayout />
          }
        >
          <Route
            path=""
            exact
            element={
              <Home />
            }
          />
          <Route
            path="users"
            exact
            element={
              <UsersAdmin />
            }
          />
          <Route
            path="models"
            exact
            element={
              <AdminModels />
            }
          />
          <Route
            path="api-keys"
            exact
            element={
              <AdminApiKeys />
            }
          />
          <Route
            path="dataset-types"
            exact
            element={
              <AdminDatasetTypes />
            }
          />
          {/* Debug page: renders GET /admin/workflow/nodes */}
          <Route
            path="workflow/nodes"
            element={
              <WorkflowNodes />
            }
          />
          <Route
            path="email-campaign/:email_campaign_id"
            exact
            element={
              <EmailCampaign />
            }
          />
          <Route
            path="email-campaign/"
            exact
            element={
              <EmailCampaign />
            }
          />
          <Route
            path="email-campaigns"
            exact
            element={
              <EmailCampaigns />
            }
          />
          <Route
            path="user/:user_id"
            exact
            element={
              <User />
            }
          />
          <Route
            path="user/"
            exact
            element={
              <User />
            }
          />
          <Route
            path="webrtc/"
            exact
            element={
              <WebRTC />
            }
          />
          <Route
            path="meet/:room_name"
            exact
            element={
              <WebRTC />
            }
          />
          <Route
            path="client/:client_id"
            exact
            element={
              <Client />
            }
          />
          <Route
            path="client/"
            exact
            element={
              <Client />
            }
          />
          <Route
            path="clients"
            exact
            element={
              <Clients />
            }
          />
          <Route
            path="agent/media/:media_id"
            element={
              <MediaItem />
            }
          />
          <Route
            path="supportingcontent/:supportingcontent_id"
            element={
              <SupportingContent />
            }
          />
          <Route
            path="supportingcontent"
            element={
              <SupportingContent />
            }
          />
          <Route
            path="lesson/:lessonID"
            element={
              <Lesson />
            }
          />
          <Route
            path="lessons/:supportingContentID"
            element={
              <Lessons />
            }
          />
          <Route
            path="agent/:agent_id"
            element={
              <Agent />
            }
          />
          <Route
            path="agent"
            element={
              <Agent />
            }
          />
          <Route
            path="agents"
            exact
            element={
              <AgentsOld />
            }
          />
          <Route
            path="workflow/:workflow_id"
            exact
            element={
              <Workflow />
            }
          />
          <Route
            path="workflow/:workflow_id/graph2"
            exact
            element={
              <div style={{ height: "100vh", width: "100vw" }}>
                <WorkflowGraph2 />
              </div>
            }
          />
          <Route
            path="workflow/:workflow_id/graph"
            exact
            element={
              <WorkflowGraph />
            }
          />
          <Route
            path="workflow/:workflow_id/graph/:archive_id"
            exact
            element={
              <WorkflowGraph />
            }
          />
          <Route
            path="workflow"
            exact
            element={
              <Workflow />
            }
          />
          <Route
            path="workflows"
            exact
            element={
              <Workflows />
            }
          />
          <Route
            path="node/"
            exact
            element={
              <Node />
            }
          />
          <Route
            path="node/:node_id"
            exact
            element={
              <Node />
            }
          />
          <Route
            path="nodes"
            exact
            element={
              <Nodes />
            }
          />
          <Route
            path="function/:function_id"
            exact
            element={
              <Function />
            }
          />
          <Route
            path="functions"
            exact
            element={
              <Functions />
            }
          />
          <Route
            path="tables"
            exact
            render={() => (
              <React.Fragment>
                <div className="pt-17">
                  <Tables />
                </div>
              </React.Fragment>
            )}
          />
          {/* apps */}
          <Route
            path="apps/parenting-trick"
            exact
            element={<ParentingTrick />}
          />

        </Route>

        {/* CLIENT VIEW */}

        <Route path="/" element={<Layout />}>
          {hasPlatformFeature("dashboard") &&
            <>
              <Route path="dashboard" element={<Dashboard />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Dashboard />} />
              }
            </>
          }
          {isAdmin && hasPlatformFeature("chat") &&
            <>
              <Route path="chat" element={<ChatSessions />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<ChatSessions />} />
              }
            </>
          }
          {isAdmin && hasPlatformFeature("responses") &&
            <>
              <Route path="responses" element={<Responses />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Responses />} />
              }
            </>
          }
          {isAdmin && hasPlatformFeature("media") &&
            <>
              <Route path="media" element={<Media />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Media />} />
              }
            </>
          }
          {isAdmin && hasPlatformFeature("train") &&
            <>
              <Route path="train" element={<Train />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Train />} />
              }
            </>
          }
          {isAdmin && hasPlatformFeature("data") &&
            <>
              <Route path="data" element={<Data />} />
              <Route path="data-set/create" element={<EditDataSet />} />
              <Route path="data-set/:data_set_id" element={<EditDataSet />} />
              <Route path="data-sets" element={<DataSets />} />
            </>
          }
          {isAdmin && hasPlatformFeature("supporting content") &&
            <>
              <Route
                path="supporting-content-items/:supportingcontent_id"
                element={<SupportingContentItems />}
              />
              <Route path="supporting-content" element={<NewSupportingContent />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<NewSupportingContent />} />
              }
            </>
          }
          {false && hasPlatformFeature("settings") &&
            <>
              <Route path="settings" element={<Settings />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Settings />} />
              }
            </>
          }
          {isAdmin && hasPlatformFeature("users") &&
            <>
              <Route path="users" element={<Users />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Users />} />
              }
            </>
          }
          {isAdmin &&
            <>
              <Route path="models" element={<Models />} />
              <Route path="api-keys" element={<ApiKeys />} />
              <Route path="app-data" element={<AppData />} />
            </>
          }
          {isAdmin && hasPlatformFeature("webrtc") &&
            <>
              <Route path="webrtc" element={<WebRTC />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<WebRTC />} />
              }
            </>
          }
          {isAdmin && hasPlatformFeature("webrtc") &&
            <Route path="meet/:room_name" element={<WebRTC />} />
          }
          {isAdmin && hasPlatformFeature("events") &&
            <>
              <Route path="events" element={<Events />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Events />} />
              }
            </>
          }
          {isAdmin && hasPlatformFeature("emails") &&
            <>
              <Route path="emails" element={<Emails />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Emails />} />
              }
            </>
          }
          {isAdmin && hasPlatformFeature("messages") &&
            <>
              <Route path="messages" element={<Messages />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Messages />} />
              }
            </>
          }
          {isAdmin && hasPlatformFeature("courses") &&
            <>
              <Route path="courses" element={<Courses />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Courses />} />
              }
              <Route path="course/generate" element={<GenerateCourse />} />
              <Route path="course/create" element={<EditCourse />} />
              <Route path="course/:course_id" element={<EditCourse />} />
              <Route path="courselevel/create" element={<EditCourseLevel />} />
              <Route path="courselevel/:course_level_id" element={<EditCourseLevel />} />
              <Route path="levelsection/create" element={<EditLevelSection />} />
              <Route path="levelsection/:level_section_id" element={<EditLevelSection />} />
              <Route path="levelsection/:level_section_id/content/:content_block_id"
                element={
                  <EditLevelSection
                    contentType="content_block"
                  />}
              />
              <Route path="levelsection/:level_section_id/quiz/:quiz_question_id"
                element={
                  <EditLevelSection
                    contentType="quiz"
                  />}
              />
            </>
          }
          {isAdmin && hasPlatformFeature("agents") &&
            <>
              <Route path="agents" element={<Agents />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Agents />} />
              }
              <Route path="agent/create" element={<EditAgent />} />
              <Route path="agent/:agent_id" element={<EditAgent />} />

              <Route path="workflow/create" element={<EditWorkflow />} />
              <Route path="workflow/:workflow_id" element={<EditWorkflow />} />
            </>
          }
          {isAdmin && hasPlatformFeature("usage") &&
            <>
              <Route path="usage" element={<Usage />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Usage />} />
              }
            </>
          }
          {isAdmin && hasPlatformFeature("editor") &&
            <Route path="editor/:content_id" element={<ContentEditor />} />
          }
          {hasPlatformFeature("editor") &&
            <>
              <Route path="editor" element={<ContentEditor />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<ContentEditor />} />
              }
            </>
          }
          {hasPlatformFeature("live events") &&
            <>
              <Route path="live-events" element={<LiveEvents />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<LiveEvents />} />
              }
            </>
          }
          {hasPlatformFeature("live events") &&
            <>
              <Route path="live-event/create" element={<EditLiveEvent />} />
              <Route path="live-event/edit/:event_id" element={<EditLiveEvent />} />
              <Route path="live-event/:event_id" element={<LiveEventDetails />} />
              <Route path="live-event/record/:event_id" element={<RecordLiveEvent />} />
              <Route path="live-event/record/:event_id/:collaborator_id" element={<RecordLiveEvent />} />
            </>
          }

        </Route>
        <Route path="/live-event/record/collaborator/:event_id" element={<RecordLiveEvent />} />
        <Route path="/live-event/record/collaborator/:event_id/:collaborator_id" element={<RecordLiveEvent />} />


        {/*
        <Route path="/client/" element={<Layout />}>
          {hasPlatformFeature("dashboard") &&
            <>
              <Route path="dashboard" element={<Dashboard />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Dashboard />} />
              }
            </>
          }
          {hasPlatformFeature("chat") &&
            <>
              <Route path="chat" element={<ChatSessions />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<ChatSessions />} />
              }
            </>
          }
          {hasPlatformFeature("responses") &&
            <>
              <Route path="responses" element={<Responses />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Responses />} />
              }
            </>
          }
          {hasPlatformFeature("media") &&
            <>
              <Route path="media" element={<Media />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Media />} />
              }
            </>
          }
          {hasPlatformFeature("train") &&
            <>
              <Route path="train" element={<Train />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Train />} />
              }
            </>
          }
          {hasPlatformFeature("supporting content") &&
            <Route
              path="supporting-content-items/:supportingcontent_id"
              element={<SupportingContentItems />}
            />
          }
          {hasPlatformFeature("supporting content") &&
            <>
              <Route path="supporting-content" element={<NewSupportingContent />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<NewSupportingContent />} />
              }
            </>
          }
          {hasPlatformFeature("settings") &&
            <>
              <Route path="settings" element={<Settings />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Settings />} />
              }
            </>
          }
          {hasPlatformFeature("users") &&
            <>
              <Route path="users" element={<Users />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Users />} />
              }
            </>
          }
          {hasPlatformFeature("webrtc") &&
            <>
              <Route path="webrtc" element={<WebRTC />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<WebRTC />} />
              }
            </>
          }
          {hasPlatformFeature("webrtc") &&
            <Route path="meet/:room_name" element={<WebRTC />} />
          }
          {hasPlatformFeature("events") &&
            <>
              <Route path="events" element={<Events />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Events />} />
              }
            </>
          }
          {hasPlatformFeature("emails") &&
            <>
              <Route path="emails" element={<Emails />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Emails />} />
              }
            </>
          }
          {hasPlatformFeature("messages") &&
            <>
              <Route path="messages" element={<Messages />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Messages />} />
              }
            </>
          }
          {hasPlatformFeature("agents") &&
            <>
              <Route path="agents" element={<Agents />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Agents />} />
              }
            </>
          }
          {hasPlatformFeature("usage") &&
            <>
              <Route path="usage" element={<Usage />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<Usage />} />
              }
            </>
          }
          {hasPlatformFeature("editor") &&
            <Route path="editor/:content_id" element={<ContentEditor />} />
          }
          {hasPlatformFeature("editor") &&
            <>
              <Route path="editor" element={<ContentEditor />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<ContentEditor />} />
              }
            </>
          }
          {hasPlatformFeature("live events") &&
            <>
              <Route path="live-events" element={<LiveEvents />} />
              {
                !foundDefaultRoute.current &&
                <Route index element={<LiveEvents />} />
              }
            </>
          }
          {hasPlatformFeature("live events") &&
            <Route path="live-event/:event_id" element={<LiveEventDetails />} />
          }
          {/*
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="landing" element={<Landing />} />
          <Route path="chat" element={<ChatSessions />} />
          <Route path="responses" element={<Responses />} />
          <Route path="media" element={<Media />} />
          <Route path="train" element={<Train />} />
          <Route
            path="supporting-content-items/:supportingcontent_id"
            element={<SupportingContentItems />}
          />
          <Route path="supporting-content" element={<NewSupportingContent />} />
          <Route path="settings" element={<Settings />} />
          <Route path="users" element={<Users />} />
          <Route path="webrtc" element={<WebRTC />} />
          <Route path="meet/:room_name" element={<WebRTC />} />
          <Route path="events" element={<Events />} />
          <Route path="emails" element={<Emails />} />
          <Route path="messages" element={<Messages />} />
          <Route path="agents" element={<Agents />} />
          <Route path="usage" element={<Usage />} />
          <Route path="editor/:content_id" element={<ContentEditor />} />
          <Route path="editor" element={<ContentEditor />} />
          <Route path="live-events" element={<LiveEvents />} />
          <Route path="live-event/:event_id" element={<LiveEventDetails />} />
        </Route>
        */}


        {/* auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" exact element={<Register />} />
        <Route
          path="/reset"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Reset />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/checkout"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Checkout />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/e-commerce"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <ECommerce />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/invoice"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Invoice />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/pricing"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Pricing />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/product"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Product />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/profile-1"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Profile1 />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/settings-1"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Settings1 />
              </div>
            </React.Fragment>
          )}
        />
        {/* error */}
        <Route
          path="/error-404"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Error404 />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/error-500"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Error500 />
              </div>
            </React.Fragment>
          )}
        />
        {/* presentation */}
        <Route
          path="/landing-1"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Landing1 />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/landing-2"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <Landing2 />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/about-us"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <AboutUs />
              </div>
            </React.Fragment>
          )}
        />
        <Route
          path="/contact-us"
          exact
          render={() => (
            <React.Fragment>
              <div className="pt-17">
                <ContactUs />
              </div>
            </React.Fragment>
          )}
        />
        {/* Product Pages - STOP */}
        {/*
        <Route path="/*" element={<Navigate to="/" replace />} />
        */}
        {!activeUser ?
          <Route path="*" element={<Login />} /> : null
        }
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
